import { connect } from 'react-redux';
import { Badge, Field, Spinner, Text, makeStyles, tokens } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';

// component functions 
import * as ComponentFunctions from './StageFix.Form.Item.Functions';

// models
import { ProtocolVisit } from '../../../../../models/Entities/Protocols/ProtocolVisit';

// components
import ProtocolVisitSelectorComponent from '../../../../../commons/component/Inputs/ProtocolVisitsSelector/ProtocolVisitSelector.Component';
import { ArrowTurnDownRight20Regular } from '@fluentui/react-icons';
import { ContractStage } from '../../../../../models/Entities/Contracts/ContractStage';

const StageFormItemComponent = (props: ComponentFunctions.Props) => {
    const styles = useStyles();
    const { t } = useTranslation();


    const onChangeVisit = (contractVisit: ContractStage, crossVersionId: number) => {
        if (contractVisit) {
            props.LinkStageToAProtocolVisit(props.ProtocolId, contractVisit.contractId, contractVisit.contractAddendumId, contractVisit.id, crossVersionId);
        }
    }

    if (!props.Stage) {
        return null;
    }

    return (
        <Field className={styles.fieldContainer}>
            <div className={styles.headerRow}>
                <div className={styles.titleGroup}>
                    <Text className={styles.title}>
                        {props.Stage.stageName}
                    </Text>
                    <Text className={styles.subtitle}>
                        {t('stageFixFormItem.subtitle', 'Seleccioná la visita protocolar asociada a esta etapa.')}
                    </Text>
                </div>
                <div className={styles.statusGroup}>
                    <Badge appearance="tint" color="brand">
                        {t('stageFixFormItem.stageOrder', { order: props.Stage.stageOrder, defaultValue: 'Etapa {{order}}' })}
                    </Badge>
                    {props.isLinkingStage && <Spinner size='extra-tiny' />}
                </div>
            </div>

            <div className={styles.selectorRow}>
                <ArrowTurnDownRight20Regular className={styles.selectorIcon} />
                {props.ProtocolId && <ProtocolVisitSelectorComponent
                    ProtocolId={props.ProtocolId}
                    onSelectedVisit={(visit: ProtocolVisit[] | ProtocolVisit | undefined) => onChangeVisit(props.Stage, (visit as ProtocolVisit)?.crossVersionId)}
                    SelectedVisitIds={props.Stage.emrProtocolVisitIdRelated ? [props.Stage.emrProtocolVisitIdRelated] : undefined}
                    ExcludedVisitIds={props.ExcludedVisitIds || []}
                    MultiselectEnable={false}
                />}
            </div>
        </Field>
    )
}

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(StageFormItemComponent as any);

const useStyles = makeStyles({
    fieldContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalM,
        border: `1px solid ${tokens.colorNeutralStroke2}`,
        backgroundColor: tokens.colorNeutralBackground1,
        borderRadius: tokens.borderRadiusLarge,
        padding: tokens.spacingHorizontalL,
    },
    headerRow: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: tokens.spacingHorizontalM,
    },
    titleGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalXS,
    },
    title: {
        fontSize: tokens.fontSizeBase300,
        lineHeight: tokens.lineHeightBase300,
        fontWeight: tokens.fontWeightSemibold,
        color: tokens.colorNeutralForeground1,
    },
    subtitle: {
        fontSize: tokens.fontSizeBase200,
        lineHeight: tokens.lineHeightBase200,
        color: tokens.colorNeutralForeground3,
    },
    statusGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: tokens.spacingHorizontalS,
    },
    selectorRow: {
        display: 'grid',
        gridTemplateColumns: '20px 1fr',
        alignItems: 'start',
        columnGap: tokens.spacingHorizontalS,
    },
    selectorIcon: {
        color: tokens.colorNeutralForeground3,
        marginTop: tokens.spacingVerticalXXS,
    },
});